var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "responsiveSection xmoHighlightsNavigation",
      attrs: { "data-sticky-nav": "" },
    },
    [
      _c("div", { staticClass: "responsiveSection__grid" }, [
        _c(
          "ul",
          {
            staticClass: "xmoHighlightsNavigation__list",
            attrs: { "data-observe-navigation": "" },
          },
          [
            _c(
              "li",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.isMaxSectionsLength,
                    expression: "!isMaxSectionsLength",
                  },
                ],
                staticClass: "xmoHighlightsNavigation__listTitle",
              },
              [
                _c(
                  "span",
                  {
                    staticClass:
                      "hl-module margin-bottom-0 text-color--dark-blue-gray",
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.trans("COLLECTION_CONTENT_HEADLINE")) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "svg",
                  {
                    staticClass: "xmoHighlightsNavigation__chevronSvg",
                    attrs: { "aria-hidden": "true" },
                  },
                  [_c("use", { attrs: { href: "#iconChevronRightSmallBold" } })]
                ),
              ]
            ),
            _vm._v(" "),
            _vm._l(_vm.sections, function (item, index) {
              return _c(
                "li",
                { key: `highlightsNavigationItem__${item.sectionKey}` },
                [
                  _c(
                    "a",
                    {
                      staticClass: "xmoHighlightsNavigation__item",
                      attrs: {
                        "data-nav-id": item.sectionKey,
                        "data-status": index === 0 ? "active" : "",
                        href: `#${item.sectionKey}`,
                        "data-gtm": `highlightsNavigationItem__${item.name}`,
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.getSectionTitle(item.title)) +
                          "\n                "
                      ),
                    ]
                  ),
                ]
              )
            }),
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }